// @ts-ignore
import {DateTime} from 'luxon';
import {CrystalclearBackUrl} from "./crystalclear-back-url";
import {TableRecordResult} from "../../model/api/table-record-result";
import {ApiValidation} from "../../model/api/api-validation";

export class CrystalclearDataAmendmentBackUrl {
  static readonly GET_ORDER_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult> = {
    url: '/api/order-amendment/list',
    type: TableRecordResult
  };
  static readonly POST_ORDER_SAVE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/order-amendment/save',
    type: ApiValidation
  };
}

